import { AppSession } from '@prisma/client'
import { Form, Input, Select, SelectProps, Switch } from 'antd'
import { InputUpload } from '~/features/formConfiguration/client/components/CustomInputs/InputUpload'
import { SelectGooglePicker } from '~/features/formConfiguration/client/components/CustomInputs/SelectGooglePicker'
import { SelectOneDrivePicker } from '~/features/formConfiguration/client/components/CustomInputs/SelectOneDrivePicker'
import { CodeInput } from '~/features/shared/components'
import { ProviderClientProperty } from '~/plugins/data-connector/types/provider.types'
import { DynamicInput } from './DynamicInput'

type Props = {
  inputs: ProviderClientProperty[]
  inputOptions?: string[]
  appSession?: AppSession
  providerAccountId?: string
}

export const InputsForm: React.FC<Props> = ({
  inputs = [],
  inputOptions = [],
  appSession,
  providerAccountId,
}) => {
  const isPicklist = (input: ProviderClientProperty) => {
    const props = input.propsInput as SelectProps
    return props?.options?.length > 0
  }

  const getName = (input: ProviderClientProperty) => {
    return input.key.split('.')
  }

  // OUTDATED
  const getComponentForInputOutdated = (input: ProviderClientProperty) => {
    return (
      <Form.Item key={input.key} name={getName(input)} {...input.propsFormItem}>
        {input.type === 'array' && (
          <Select mode="multiple" {...(input.propsInput as any)} options={[]} />
        )}

        {input.type === 'boolean' && (
          <Switch size="small" {...(input.propsInput as any)} />
        )}

        {input.type === 'number' && (
          <Input type="number" {...(input.propsInput as any)} />
        )}

        {!isPicklist(input) && (!input.type || input.type === 'string') && (
          <DynamicInput {...(input.propsInput as any)} options={inputOptions} />
        )}

        {isPicklist(input) && <Select {...(input.propsInput as any)} />}

        {input.type === 'object' && (
          <CodeInput {...(input.propsInput as any)} />
        )}
      </Form.Item>
    )
  }

  const getComponentForInput = (input: ProviderClientProperty) => {
    if (input.type && !input.inputType) {
      return getComponentForInputOutdated(input)
    }

    return (
      <Form.Item key={input.key} name={getName(input)} {...input.propsFormItem}>
        {input.inputType === 'Select' && (
          <Select mode="multiple" options={[]} {...(input.propsInput as any)} />
        )}

        {input.inputType === 'Switch' && (
          <Switch size="small" {...(input.propsInput as any)} />
        )}

        {input.inputType === 'Input' && (
          <Input {...(input.propsInput as any)} />
        )}

        {input.inputType === 'CodeInput' && (
          <CodeInput {...(input.propsInput as any)} />
        )}

        {input.inputType === 'Upload' && (
          <InputUpload
            {...(input.propsInput as any)}
            formValuesConfiguration={{ appSessionId: appSession?.id }}
          />
        )}

        {input.inputType === 'GooglePicker' && (
          <SelectGooglePicker
            {...(input.propsInput as any)}
            formValuesConfiguration={{ providerAccountId }}
            providerAccountId={providerAccountId}
          />
        )}

        {input.inputType === 'OneDrivePicker' && (
          <SelectOneDrivePicker
            {...(input.propsInput as any)}
            formValuesConfiguration={{ providerAccountId }}
            providerAccountId={providerAccountId}
          />
        )}

        {!input.inputType && (
          <DynamicInput {...(input.propsInput as any)} options={inputOptions} />
        )}
      </Form.Item>
    )
  }

  return inputs.map(input => getComponentForInput(input))
}
